import ReactDOM from 'react-dom/client';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import Education from './pages/Education';
import Experience from './pages/Experience';
import NoPage from './pages/NoPage';
import Projects from './pages/Projects';
import Publications from './pages/Publications';
import Talks from './pages/Talks';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/home" element={<App />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/experience" element={<Experience />} />
      <Route path="/education" element={<Education />} />
      <Route path="/publications" element={<Publications />} />
      <Route path="/talks" element={<Talks />} />
      <Route path="*" element={<NoPage />} />
    </Routes>
  </BrowserRouter>
);
